import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { EMPTY_STRING, inventoryConstants } from "../../../constants";
import { getDisplayProductTags } from "../../utility";

const TitleToolTip = ({
  title = EMPTY_STRING,
  children,
  placement = "bottom",
}) => {
  const id = `${Math.random() * 10}-${title}`;
  let toolTipTitle = title;
  // if title is an array (sku, tag) then convert into jsx
  if (Array.isArray(title) && title.length) {
    toolTipTitle = (
      <>
        {getDisplayProductTags(title) 
          .map((s, index) => (
            <p
              className="sku-wrapper text-nowrap text-start fw-normal m-0"
              key={index}
            >
              {s}
            </p>
          ))}
      </>
    );
  }

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip id={id} className="title-tooltip">
          {toolTipTitle}
        </Tooltip>
      }
    >
      <span>{children}</span>
    </OverlayTrigger>
  );
};

export default TitleToolTip;
